import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";

export const selectedMatriculaState = atom({
  key: 'selectedMatriculaState',
  default: {},
  effects: [
    persistAtomEffect
  ]
});
